import Axios from "@/plugins/Axios";
import EducacaoInclusiva from "@/Models/EducacaoInclusiva";

export class EducacaoInclusivaService {
  async syncAll(form) {
    const response = await Axios().post(`educacao-inclusiva`, form);
    const payload = response.data;
    return new EducacaoInclusiva(payload);
  }

  async syncAllPaginate(pageNumber, query) {
    const response = await Axios().get(
      `educacao-inclusiva/listall/paginate?page=${pageNumber}&query=${query}`
    );
    return response.data;
  }

  async lancar(form) {
    await Axios().post(`educacao-inclusiva/salvar-relatorio`, form);
  }

  async listar(matricula_id) {
    const response = await Axios().get(`educacao-inclusiva/matricula/${matricula_id}`);
    return response.data;
  }

  async remover(id) {
    await Axios().delete(`educacao-inclusiva/${id}`);
  }
}
export default new EducacaoInclusivaService();
